
document.addEventListener('DOMContentLoaded', function() {
  const thumbs = new Swiper('.product-gallery-thumbs', {
    spaceBetween: 10,
    slidesPerView: 5,
    freeMode: true,
    watchSlidesProgress: true,
    breakpoints: {
      0: { slidesPerView: 4 },
      768: { slidesPerView: 5 },
    },
  });

  const main = new Swiper('.product-gallery-main', {
    loop: true,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: { swiper: thumbs },
  });
});



  document.querySelectorAll('.header__inline-menu details').forEach((menu) => {
    menu.addEventListener('mouseenter', () => {
      menu.setAttribute('open', true);
    });

    menu.addEventListener('mouseleave', () => {
      menu.removeAttribute('open');
    });
  });